import React, { useEffect, useState } from "react";
import getCountryCurrencyCode from "../../Main/getCountryCurrencyCode";

const UserCurrency = () => {
  const [currencyCode, setCurrencyCode] = useState("");

  useEffect(() => {
    const fetchCurrency = async () => {
      const code = await getCountryCurrencyCode();
      setCurrencyCode(code); 
    };

    fetchCurrency();
  }, []);

  return <span>{currencyCode || "..."}</span>;
};

export default UserCurrency;